module.exports = __webpack_public_path__ + "imgs/wheresweed-home-hero.0b566a5ce64a0dbcef951392e732075c.jpg";